const groupsActions = {

    //GROUPS
    LOAD_MY_GROUPS_START: 'LOAD_MY_GROUPS_START',
    LOAD_MY_GROUPS_SUCCESS: 'LOAD_MY_GROUPS_SUCCESS',
    LOAD_MY_GROUPS_FAILED: 'LOAD_MY_GROUPS_FAILED',

    //CREATE_GROUP
    CREATE_GROUP_START: "CREATE_GROUP_START",
    CREATE_GROUP_SUCCESS: "CREATE_GROUP_SUCCESS",
    CREATE_GROUP_FAILED: "CREATE_GROUP_FAILED",

    //EDIT_GROUP
    EDIT_GROUP_START: "EDIT_GROUP_START",
    EDIT_GROUP_SUCCESS: "EDIT_GROUP_SUCCESS",
    EDIT_GROUP_FAILED: "EDIT_GROUP_FAILED",

    //DELETE_GROUP
    DELETE_GROUP_START: 'DELETE_GROUP_START',
    DELETE_GROUP_SUCCESS: 'DELETE_GROUP_SUCCESS',
    DELETE_GROUP_FAILED: 'DELETE_GROUP_FAILED',

    //ABANDON_GROUP
    ABANDON_GROUP_START: 'ABANDON_GROUP_START',
    ABANDON_GROUP_SUCCESS: 'ABANDON_GROUP_SUCCESS',
    ABANDON_GROUP_FAILED: 'ABANDON_GROUP_FAILED',

    //UNASSIGN_MEMBER
    UNASSIGN_MEMBER_START: 'UNASSIGN_MEMBER_START',
    UNASSIGN_MEMBER_SUCCESS: 'UNASSIGN_MEMBER_SUCCESS',
    UNASSIGN_MEMBER_FAILED: 'UNASSIGN_MEMBER_FAILED',

    //INVITE_MEMBER
    INVITE_MEMBER_START: 'INVITE_MEMBER_START',
    INVITE_MEMBER_SUCCESS: 'INVITE_MEMBER_SUCCESS',
    INVITE_MEMBER_FAILED: 'INVITE_MEMBER_FAILED',

    //CLEAR_FLAGS
    CLEAR_FLAGS: 'CLEAR_FLAGS',

    // SEARCH
    SET_SEARCH_GROUP_TEXT: 'SET_SEARCH_GROUP_TEXT',

    // Groups Actions
    createLoadMyGroupsActionStart: () => {
        return {
            type: groupsActions.LOAD_MY_GROUPS_START,
        };
    },
    createLoadMyGroupsActionSuccess: (remodelumGroups) => {
        return {
            type: groupsActions.LOAD_MY_GROUPS_SUCCESS,
            payload: remodelumGroups,
        };
    },
    createLoadMyGroupsActionFailed: (remodelumGroupsError) => {
        return {
            type: groupsActions.LOAD_MY_GROUPS_FAILED,
            payload: remodelumGroupsError,
        };
    },
    createCreateGroupActionStart: (group) => {
        return {
            type: groupsActions.CREATE_GROUP_START,
            payload: group,
        };
    },
    createCreateGroupActionSuccess: (groupsSuccess) => {
        return {
            type: groupsActions.CREATE_GROUP_SUCCESS,
            payload: groupsSuccess,
        };
    },
    createCreateGroupActionFailed: (groupsError) => {
        return {
            type: groupsActions.CREATE_GROUP_FAILED,
            payload: groupsError,
        };
    },
    createEditGroupActionStart: (group) => {
        return {
            type: groupsActions.EDIT_GROUP_START,
            payload: group,
        };
    },
    createEditGroupActionSuccess: (groupsSuccess) => {
        return {
            type: groupsActions.EDIT_GROUP_SUCCESS,
            payload: groupsSuccess,
        };
    },
    createEditGroupActionFailed: (groupsError) => {
        return {
            type: groupsActions.EDIT_GROUP_FAILED,
            payload: groupsError,
        };
    },
    createDeleteGroupActionStart: (payload) => {
        return {
            type: groupsActions.DELETE_GROUP_START,
            payload: payload,
        };
    },
    createDeleteGroupActionSuccess: (groupsSuccess) => {
        return {
            type: groupsActions.DELETE_GROUP_SUCCESS,
            payload: groupsSuccess,
        };
    },
    createDeleteGroupActionFailed: (groupsError) => {
        return {
            type: groupsActions.DELETE_GROUP_FAILED,
            payload: groupsError,
        };
    },
    createAbandonGroupActionStart: (payload) => {
        return {
            type: groupsActions.ABANDON_GROUP_START,
            payload: payload,
        };
    },
    createAbandonGroupActionSuccess: (groupsSuccess) => {
        return {
            type: groupsActions.ABANDON_GROUP_SUCCESS,
            payload: groupsSuccess,
        };
    },
    createAbandonGroupActionFailed: (groupsError) => {
        return {
            type: groupsActions.ABANDON_GROUP_FAILED,
            payload: groupsError,
        };
    },
    createUnassignMemberActionStart: (payload) => {
        return {
            type: groupsActions.UNASSIGN_MEMBER_START,
            payload: payload,
        };
    },
    createUnassignMemberActionSuccess: (groupsSuccess) => {
        return {
            type: groupsActions.UNASSIGN_MEMBER_SUCCESS,
            payload: groupsSuccess,
        };
    },
    createUnassignMemberActionFailed: (groupsError) => {
        return {
            type: groupsActions.UNASSIGN_MEMBER_FAILED,
            payload: groupsError,
        };
    },
    createInviteMemberActionStart: (payload) => {
        return {
            type: groupsActions.INVITE_MEMBER_START,
            payload: payload,
        };
    },
    createInviteMemberActionSuccess: (groupsSuccess) => {
        return {
            type: groupsActions.INVITE_MEMBER_SUCCESS,
            payload: groupsSuccess,
        };
    },
    createInviteMemberActionFailed: (groupsError) => {
        return {
            type: groupsActions.INVITE_MEMBER_FAILED,
            payload: groupsError,
        };
    },
    clearFlags: (payload) => {
        return {
            type: groupsActions.CLEAR_FLAGS,
            payload: payload,
        };
    },
    setSearchGroupText: (payload) => {
        return {
            type: groupsActions.SET_SEARCH_GROUP_TEXT,
            payload,
        };
    },
};

export default groupsActions;
